import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import { SettingsContentPanel } from 'app/components/common/SettingsContentPanel';
import { Button, Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

export interface MonitoredEventsFilters {
    types: string[];
    options: string[];
}

export class MonitoredEventsFiltersTitle extends PureComponent {
    render() {
        return (
            <Flex direction="vertical">
                <div style={{ fontWeight: 'bold' }}>EVENTS FILTERS</div>
            </Flex>
        );
    }
}

export class MonitoredEventsFiltersContent extends SettingsContentPanel<MonitoredEventsFilters> {
    onChange = (value: CheckboxChangeEvent, option: string) => {
        this.setState({
            types: value.target.checked ? [...this.state.types, option] : this.state.types.filter(o => o !== option),
        });
    };

    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '20em', padding: '1em' }}>
                <Flex direction="vertical">
                    {this.state.options?.map(option => (
                        <Flex key={option} style={{ paddingBottom: '0.5em' }}>
                            <Checkbox
                                checked={this.state.types.includes(option)}
                                onChange={value => this.onChange(value, option)}>
                                {option}
                            </Checkbox>
                        </Flex>
                    ))}
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}
